import { contentV1GetPresetDatasourceVersionsOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetDatasourcePresetVersions = ({
  name = '',
}: {
  name: string | undefined | null;
}) => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...contentV1GetPresetDatasourceVersionsOptions({
      ...defaultOptions(),
      path: { workspace, name: name ?? '' },
    }),
    enabled: !!workspace && !!name,
  });
};
